module.exports = __webpack_public_path__ + "img/21.caec6015.jpg";